import React, { useContext, useState, useEffect } from "react";
import { Formik } from "formik";
import { create } from "../../api/api-user";
import { StateContext } from "../../contexts/StateContext";
import {
  Image,
  Row,
  Col,
  Container,
  ButtonGroup,
  Button,
  Form,
  InputGroup,
  Stack,
} from "react-bootstrap";
import * as Yup from "yup";
import { CustomField } from "./CustomField.js";

const schema = Yup.object().shape({
  username: Yup.string()
    .min(3, "Username is to short")
    .required("This field is required"),
  email: Yup.string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: Yup.string()
    .min(
      8,
      "Password must be at least 8 characters long consisting of a to z letters, capital letter and special charachter"
    )
    .required("This field is required"),
  password2: Yup.string("Repeat your password")
    .required("Password is required")
    .oneOf([Yup.ref("password")], "Your passwords do not match."),
});

const Register = ({ setShowLoginModal, setRegister }) => {
  const { user, setUser } = useContext(StateContext);
  const [apiError, setApiError] = useState("");

  const onSubmitHandler = async (e, values) => {
    e.preventDefault();
    const user = {
      username: values.username || undefined,
      email: values.email || undefined,
      password: values.password || undefined,
    };
    try {
      const response = await create(user);
      if (response?.user) {
        setUser(response.user);
        setApiError("");
        setShowLoginModal(false);
        setRegister(false);
      } else if (response?.error) {
        setApiError(
          response?.error?.response?.data.error || response.error.message
        );
        console.log(response);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="right-pane">
      <Formik
        initialValues={{
          username: "",
          password: "",
          password2: "",
          email: "",
        }}
        validationSchema={schema}
      >
        {({ isValid, dirty, isSubmitting, values }) => (
          <Form>
            <CustomField label="Username" name="username" />
            <CustomField label="Email" name="email" />
            <CustomField label="Password" name="password" type="password" />
            <CustomField
              label="Repeat password"
              placeholder="Password"
              name="password2"
              type="password"
            />
            <button
              disabled={!(isValid && dirty) || isSubmitting}
              onClick={(e) => {
                onSubmitHandler(e, values);
              }}
            >
              SIGN UP
            </button>
            <div className="error-message">{apiError}</div>
          </Form>
        )}
      </Formik>
      <div>
        Already have an account, &nbsp;
        <span
          className="text-primary"
          onClick={() => {
            setRegister(false);
          }}
        >
          Sign in
        </span>
      </div>
    </div>
  );
};

export default Register;
